module.exports = __webpack_public_path__ + "static/media/paymentback.397be089.jpg";